<template>
  <div>
    <div>
      <div class="loader-wrapper" v-show="loader.summary && !hideTotal"></div>      
      <h2>{{$t('total_balance.account')}}: {{login}}</h2>
      <div v-if="!hideTotal">
        <p>{{$t('profile.total_deposit_funds')}}</p>
        <p class="total">$ {{totalFunds | formatNumber}}</p>
      </div>
    </div>
  </div>
</template>


<script>

  import EventBus from '../event-bus';
  import { getSummary } from '@/services/MT4Service';
  import AccountService from '@/services/AccountService';

  let accountService = new AccountService();

  export default {
    name: 'total-balance',
    props: {
      hideTotal : false
    },
    data: function () {
      return {
        totalFunds: 0,
        login: 0,
        loader: {
          summary: true
        }
      };
    },
    methods: {
      populateComponent() {
        let t = this;
        let mt4 = null;
        t.loader.summary = true;
        t.totalFunds = '0.00';
          accountService.getMT4Accounts().then(r => {
            r.data.forEach(element => {
              if (element.default) {
                t.login = element.login;
                t.mt4 = element;
              }
            });
            return r;
          }).then((r) => {
            getSummary(t.mt4).then(function (r) {
              t.totalFunds = r.data.balance;
              t.loader.summary = false;
              t.$emit('balanceChanged', t.totalFunds);
            });
          });
        
      }
    },
    created() {
       EventBus.$on("onUpdateComponent", r => {
         this.populateComponent();
       });

      this.populateComponent();
    }
  };
</script>




// WEBPACK FOOTER //
// src/components/TotalBalance.vue